<template>
    <Layout>
      <div class="row">
        <div class="col-12">
                <div class="row">
                  <div class="col-md-4">
                    <div class="card patient-summary-card">
                    <div class="card-header patient-summary-header"><div v-html="theservice"></div></div>
                    <div class="card-body p-3">
                      <div class="mb-3 d-flex justify-content-between align-items-start gap-3">
                        <div class="patient-summary-hero">
                          <img class="img-rounded patient-summary-avatar" src="@/assets/images/sick.png" height="70px" />
                        </div>
                        <span><a @click="$router.go(-1)" type="button" class="btn-sm btn btn-primary patient-summary-back"> <i class="mdi mdi-undo"></i> back</a></span>
                      </div>
                      <span v-if="patientspinner==false">
                      <div v-for="item in patients" :key="item.id" class="patient-summary-fields">
                        <div class="patient-summary-row">
                          <span class="patient-summary-label">Full Name</span>
                          <span class="patient-summary-value"><b>{{ item.name }}</b></span>
                        </div>
                        <div class="patient-summary-row">
                          <span class="patient-summary-label">Gender</span>
                          <span class="patient-summary-value">{{ item.gender }}</span>
                        </div>
                        <div class="patient-summary-row">
                          <span class="patient-summary-label">Telephone</span>
                          <span class="patient-summary-value">0{{ item.telephone }}</span>
                        </div>
                        <div class="patient-summary-row">
                          <span class="patient-summary-label">Date of Birth</span>
                          <span class="patient-summary-value">{{ item.date_of_birth }}</span>
                        </div>
                        <div class="patient-summary-row">
                          <span class="patient-summary-label">Email Address</span>
                          <span class="patient-summary-value">{{ item.email }}</span>
                        </div>
                        <div class="patient-summary-row">
                          <span class="patient-summary-label">Address</span>
                          <span class="patient-summary-value">{{ item.address }}</span>
                        </div>
                        <div class="patient-summary-row">
                          <span class="patient-summary-label">Nationality</span>
                          <span class="patient-summary-value">{{ item.nationality }}</span>
                        </div>
                      </div>
                      </span>
                      <span v-else>
                        <div class="patient-summary-loading">
                          <i class="fas fa-spinner fa-3x p-5 text-primary fa-spin"></i>
                        </div>
                      </span>
                    </div>
                    </div>
                  </div>
                  <div class="col-md-8">
                    <b-tabs pills nav-class="p-0" content-class="text-dark">
                      <b-tab active class="border-0">
                        <template v-slot:title>Diagnosis</template>
                        <div class="card">
                          <div class="card-body">
                              <h5 class="text-primary">Services</h5>
                              <table class="table table-sm mt-2" style="color: black;" density="compact">
                              <thead><tr><th>Category</th><th>Service Name</th><th>Service Price</th></tr></thead>
                              <tbody>
                                <tr v-for="item in services" :key="item.id">
                                    <td>{{ item.service_category.name }} </td>
                                    <td v-if ="isPaymentTypeValid">{{ item.service_name.name  }}</td>
                                    <td v-else>{{ item.insurance_service_name.name  }}</td>
                                    <td>{{ item.service_price }}</td>
                                </tr>
                              </tbody>
                              </table>
                              <h5 class="text-primary">Provisional Diagnosis</h5>
                                <span v-for="item in diagnosis" :key="item.id">
                                  <div class="row">
                                    <div class="col-md-6">
                                      <span>Presented Complaints <span class="text-info h5" v-html="item.symptoms"></span></span>
                                      <span>History of Presented Complaints <span class="text-info h5" v-html="item.history"></span></span>
                                      <span>General Examination to Review of Systems <span class="text-info h5" v-html="item.examination"></span></span>
                                    </div>
                                    <div class="col-md-6" style="border-left: 1px solid grey;">
                                      <span>Provisional Diagnosis <span class="text-info h5" v-html="item.diagnosis"></span></span>
                                      <span>Recommendation <span class="text-info h5" v-html="item.recommedation"></span></span>
                                    </div>
                                  </div>
                                </span>
                          </div>
                        </div>
                      </b-tab>
                      <b-tab class="border-0">
                          <template v-slot:title>Presciptions</template>
                          <div class="card">
                            <div class="card-body">
                              <div class="card">
                                <table class="table table-sm" style="color: black;" density="compact">
                                <thead><tr><th>Medicine</th><th>Dosage</th><th>Note</th><th>#</th></tr></thead>
                                <tbody>
                                    <tr v-for="item in prescriptions" :key="item.id">
                                    <td>{{ item.medicine.name }} </td>
                                    <td>{{ item.dosage }}</td>
                                    <td>{{ item.note }}</td>
                                    <td>
                                      <b-button @click="give(item.medicine.id,item.medicine.name,item.dosage)" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-pill"></i> </b-button>
                                    </td>
                                    </tr>
                                </tbody>
                                </table>
                                <h5 class="text-primary">Medications</h5>
                                <table class="table table-sm mt-2" style="color: black;" density="compact">
                                <thead><tr><th>Medicine</th><th>Quantity</th><th>Date/Time</th></tr></thead>
                                <tbody>
                                  <tr v-for="item in medications" :key="item.id">
                                      <td>{{ item.medicine.name }} </td>
                                      <td>{{ item.quantity }}</td>
                                      <td>{{ item.created_at }}</td>
                                  </tr>
                                </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                      </b-tab>
                      <b-tab class="border-0">
                          <template v-slot:title>Consumables</template>
                          <div class="card">
                            <div class="card-body">
                              <b-button v-b-modal.new-consumables size="sm" variant="primary"><i class="mdi mdi-plus"></i> Give Consumables</b-button>
                              <div class="card">
                                <table class="table table-sm table-bordered" style="color: black;" density="compact">
                                <thead><tr><th>Consumable</th><th>Quantity</th><th>Price</th></tr></thead>
                                <tbody>
                                    <tr v-for="item in consumables" :key="item.id">
                                    <td>{{ item.consumbale.name }} </td>
                                    <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
                                    <td>{{ item.totalprice }}</td>
                                    </tr>
                                </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
        </div>
      </div>
  
      <b-modal id="new-prescription" centered title="Give Prescription" title-class="font-18" hide-footer>
          <form @submit.prevent="addPrescription">
            <div class="form-group mb-2">
              <label>Medicine</label>
                <input v-model="pre_medicine_id" type="number" hidden class="form-control" />
                <input v-model="pre_medicine" type="text" style="background: none;" readonly class="form-control" />
              </div>
              <label>Dose</label>
                <input v-model="pre_dose" type="text" readonly style="background: none;" class="form-control" />
                <label>Quantity</label>
                <input v-model="pre_quantity" type="number" min="1" required class="form-control" />
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-prescription')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>

      <b-modal id="new-consumables" centered title="Give Consumables" title-class="font-18" hide-footer>
          <form @submit.prevent="addConsumables">
            <div class="form-group mb-2">
              <label>Consumable</label>
                <multiselect v-model="medicine" @input="FilterProductUnits" :options="products" label="name"></multiselect>
              </div>
              <label>Unit</label>
                <multiselect v-model="unit" @input="FilterPrice" :options="units" label="unit"></multiselect>
              <label>Price</label>
                <input v-model="price" type="number" readonly class="form-control" />
                <label>Quantity</label>
                <input v-model="quantity" type="number"  @input="CheckMedicine" min="1" required class="form-control" />
              <div class="form-group mb-2">
              <label>Total Amount</label>
                <input v-model="totalprice" type="number" readonly class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-consumables')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import appConfig from "@/app.config";
  import Multiselect from "vue-multiselect";
  import { productMethods, productComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Patient Treatment",
      meta: [{name: "description",content: appConfig.description,},],
    },
    components: {
      Layout,Multiselect,
    },
    data() {
      return {
        title: "Patient Treatment",
        items: [{text: "Dashboard",to: "/",},{text: "Patients",active: true,},],
        patients:[],
        services:[],
        prescriptions:[],
        consumables:[],
        patientspinner:true,
        patientid:'',
        theservice:'',
        visitid:'',
        medicine:'',
        price:'',
        quantity:'1',
        units:[],
        unit:'',
        totalprice:'',
        diagnosis:[],
        medicines:[],
        medications:[],
        pre_medicine_id:'',
        pre_medicine:'',
        pre_dose:'',
        pre_quantity:1,
        pay_type:'',
      };
    },
    computed: {
        ...productComputed,
        isPaymentTypeValid() {
          return this.pay_type != '4';
         },
    },
    created() {
      this.fetchProducts();
      this.fetchInfo();
    },
    methods: {
      ...productMethods,
      async fetchInfo(){
        this.id=this.$route.query.id;
        let url = `/inpatientinfo/${this.id}`;
        await axios.get(url).then((response) => {
          this.patientid = response.data.patients[0].patient.patient_id;
          this.visitid = response.data.patients[0].visit_id;
          this.theservice = response.data.patients[0].diagnosis;
          
          this.showpatient();
          this.showtprescriptions();
          this.showtconsumables();
          this.showtmedications();
          this.showservices();
        });
      },
      give(id,medicine,dose){
      this.pre_medicine_id=id;
      this.pre_medicine=medicine;
      this.pre_dose=dose;
      this.$bvModal.show('new-prescription')
    },
      CheckMedicine(){ this.totalprice = this.price*this.quantity; },
      async FilterProductUnits(){
          let url = `/unitsbyproduct/${this.medicine.id}`;
          await axios.get(url).then((response) => {
            this.units = response.data.units;
             });
    },
        async FilterPrice(){
          let url = `/productbyunitprice/${this.unit.unit_id},${this.medicine.id}`;
          await axios.get(url).then((response) => {
            this.price = response.data.price;
            this.CheckMedicine();
            });
        },
      async showpatient(){
        let url = `/patientprofile/${this.patientid}`;
        await axios.get(url).then((response) => {
          this.patients = response.data.patients;
          this.patientspinner=false;
        });
      },
      async showservices(){
        let url = `/profileservices/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.services = response.data.visits;
          this.insurance_company = response.data.visits[0].insurance_service_name.insurance_id;
          this.insurance_package = response.data.visits[0].insurance_service_name.package_id;
          this.insurance_categorys = response.data.visits[0].insurance_service_name.category;
          this.pay_type = response.data.visits[0].patientvisit.payment_type;

        });
        let url1 = `/profilediagnosis/${this.patientid},${this.visitid}`;
        await axios.get(url1).then((response) => {
          this.diagnosis = response.data.treatments;
        });
      },
      async showtprescriptions(){
        let url = `/profileprescription/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.prescriptions = response.data.prescriptions;
        });
      },
      async showtconsumables(){
        let url = `/profileconsumables/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.consumables = response.data.consumables;
        });
      },
      async addConsumables() {
        let formData = new FormData();
        formData.append("patient_id", this.patientid);
        formData.append("visit_id", this.visitid);
        formData.append("medicine", this.medicine.id);
        formData.append("unit", this.unit.unit_id);
        formData.append("quantity", this.quantity );
        formData.append("totalprice", this.totalprice);
        let url = "/addconsumables";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.$bvModal.hide('new-consumables');
            this.showtconsumables();
            this.medicine="";
            this.quantity="";
            this.$toast.success("Patient Consumables Added");
        }
        });
      },
      async showtmedications(){
        let url = `/profilemedications/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.medications = response.data.medications;
        });
      },
      async addPrescription() {
        let formData = new FormData();
        formData.append("patient_id", this.patientid);
        formData.append("visit_id", this.visitid);
        formData.append("medicine", this.pre_medicine_id);
        formData.append("quantity", this.pre_quantity );
        let url = "/giveprescription";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.$bvModal.hide('new-prescription');
            this.showtmedications();
            this.pre_medicine="";
            this.quantity="";
            this.$toast.success("Patient Prescription Given");
        }
        });
      }
    },
  };
  </script>

<style scoped>
.patient-summary-card {
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
}

.patient-summary-header {
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
  border-bottom: 0;
  padding: 1rem 1.25rem;
  font-weight: 700;
  min-height: 78px;
  display: flex;
  align-items: center;
}

.patient-summary-hero {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.patient-summary-avatar {
  width: 78px;
  height: 78px;
  object-fit: contain;
}

.patient-summary-back {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding-inline: 0.85rem;
}

.patient-summary-fields {
  display: grid;
  gap: 0.85rem;
}

.patient-summary-row {
  display: grid;
  grid-template-columns: minmax(130px, 150px) minmax(0, 1fr);
  gap: 0.9rem;
  align-items: start;
}

.patient-summary-label {
  color: #334155;
  font-weight: 600;
  line-height: 1.45;
}

.patient-summary-value {
  color: #0f766e;
  line-height: 1.45;
  word-break: break-word;
}

.patient-summary-loading {
  display: flex;
  justify-content: center;
}

@media (max-width: 767.98px) {
  .patient-summary-row {
    grid-template-columns: 1fr;
    gap: 0.25rem;
  }
}
</style>
